import { useState, useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

export interface Settings {
  aiModel: string;
  useMockSerpAPI: boolean;
}

const STORAGE_KEY = 'landingator_settings';

export function useSettings() {
  const [settings, setSettingsState] = useState<Settings>({
    aiModel: 'gpt-4.1-mini',
    useMockSerpAPI: false,
  });

  // Load on mount
  useEffect(() => {
    (async () => {
      const raw = await AsyncStorage.getItem(STORAGE_KEY);
      if (raw) {
        try {
          setSettingsState(JSON.parse(raw));
        } catch {
          /* ignore parse errors */
        }
      }
    })();
  }, []);

  // Setter that persists
  const setSettings = async (newSettings: Partial<Settings>) => {
    const merged = { ...settings, ...newSettings };
    setSettingsState(merged);
    await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  };

  return { settings, setSettings };
  
}
